import React, { useEffect, useState } from "react";

const DematDropdown = ({
  className,
  data,
  valueKey,
  displayKey,
  filterKey,
  setFilter,
}) => {
  const [value, setValue] = useState();
  const [uniqueDemats, setUniqueDemats] = useState([]);

  useEffect(() => {
    setValue("");
    if (data?.length > 0) {
      const unique = {};
      const uniqueData = data?.filter((item) => {
        if (!unique[item[displayKey]]) {
          unique[item[displayKey]] = true;
          return true;
        }
        return false;
      });
      setUniqueDemats(uniqueData);
    } else {
      setUniqueDemats([]);
    }
  }, [data]);

  useEffect(() => {
    if (value && value !== "") {
      setFilter((prev) => ({ ...prev, [filterKey]: value }));
    } else {
      setFilter((prev) => ({ ...prev, [filterKey]: null }));
    }
  }, [value]);

  return (
    <div className="flex h-full w-full flex-col gap-2 rounded-[4px] bg-[#f5f5f5]">
      <div className="h-full rounded bg-transparent px-[1px] py-[1px] ">
        <select
          className={`${
            className ? className : "w-full"
          }   bg-transparent py-[0.4rem] text-[14px] text-[#868686]  focus:outline-none`}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        >
          <option value={""} className="text-[#CFCFCF]">
            Select Demat Name
          </option>
          {uniqueDemats?.map((item) => (
            <option value={item[valueKey]} className="text-[#868686]">
              {item[displayKey]}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default DematDropdown;
